import { render } from "./MappingItem.vue?vue&type=template&id=4e228416&scoped=true"
import script from "./MappingItem.vue?vue&type=script&lang=js"
export * from "./MappingItem.vue?vue&type=script&lang=js"

import "./MappingItem.vue?vue&type=style&index=0&id=4e228416&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e228416"]])

export default __exports__